import { AboutBody } from "../public/about";

// In-app About Us (Platform Owner → Settings → About Us).
const AboutPage = () => (
  <div className="dashboard">
    <section className="panel">
      <div className="panel__head">
        <div>
          <h2>About Us</h2>
        </div>
      </div>
      <div className="panel__body">
        <AboutBody />
      </div>
    </section>
  </div>
);

export default AboutPage;
